<template>
	<section>
		<!-- Componentes externos -->

    <h3 class="primary--text"><v-icon color="primary">business</v-icon> Lista de servidores públicos</h3>
		<v-card>
			<v-card-text>
			  <crud-table
          :headers="headers"
          :url="url"
          :filters="filters"
          :data-graphql="dataGraphql"
          :graphql="graphql"
          :initData="initData"
        >
          <!-- Template de filas y columnas -->
          <template slot="items" slot-scope="items">
            <!-- Agregar las columnas que considere necesarias -->
            <!-- <td class="text-xs-center">{{ items.item.nro_doc }}</td> -->
            <td class="text-xs-center">{{ items.item.nombre }}</td>
          
            <td class="text-xs-center">{{ items.item.item }} </td>
            <!-- <td class="text-xs-center">{{ items.item.unidad }}</td> -->
            <td class="text-xs-center">
              <v-btn
                color="success"
                title="Registrar asistencia servidor público"
                :to="`/registro-manual-asistencia/listado/${items.item.id_persona}`"
              >
                Registro de asistencia manual
              </v-btn>

               <v-btn
                v-if="items.item.es_autoridad == 1"
                color="primary"
                title="Registrar asistencia autoridad"
                :to="`/registro-manual-asistencia-autoridad/listado/${items.item.id_persona}`"
              >
                Registro de asistencia manual autoridades
              </v-btn>
            </td>
          </template>
        </crud-table>
			</v-card-text>
		</v-card>
	</section>
</template>

<script>
import CrudTable from '@/common/util/crud-table/CrudTable.vue'; // Componente Tabla Dinámica
import crud from '@/common/util/crud-table/mixins/crud-table'; // Funciones y Metodos

export default {
	// Importación de métodos y funciones de un archivo mixin 
	mixins: [crud],
	// Variables iniciales del componente
	data () {
		return {
			 url: "vListaPersonals",
      graphql: true,
      // Cabecera de la tabla
      headers: [
        // { text: "Número de documento", value: "nro_doc", align: "center" },
        { text: "Nombres", value: "nombre", align: "center" },
        { text: "Ítem", value: "item", align: "center" },
        // { text: "Unidad", value: "unidad", align: "center" },
        { text: this.$t("common.actions"), sortable: false, align: "center" },
      ],
      // Campos solicitados de Graphql(Agregar los que necesite)
      dataGraphql: `
        id_persona
        id_estado
        nro_doc
        nro_complemento
        item
        nombre
        unidad
        fecha_ingreso
        cargo
        id_cargo
        id_puesto
        id_item
        id_unidad
        id_movilidad
        estado
        es_autoridad
      `,
      filters: [
        
        {
          field: "nombre",
          label: "Nombres",
          type: "text",
          typeG: "String",
        },
        
        {
          field: "item",
          label: "Ítem",
          type: "number",
          typeG: "String",
        },
     
       
      ],
      initData: [
        {
          state: true,
          param: "id_estado",
          value: 1,
        },
        {
          state: true,
          param: "l_tipo_persona",
          value:[1],
        },
      ],
		}
	},
	// Funcionalidades que se ejecutan al montar el componente
  mounted () {
    // Verificando si el usuario tiene permiso para interactual con el componente
    const rolesPermitidos = [0] // ID's de roles permitidos
    if (!this.$util.permisoRol(rolesPermitidos)) {
      this.$router.push('/403')
    }
        this.onFilter()
    this.$bus.$on('closeDialog', () => {
      this.updateList()
    })
  },
	// Métodos y funciones del componente
	methods: {

	},
	// Definición de componentes importados
	components: {
		CrudTable,
	
	}
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/admin/registro_manual_asistencia/Index.vue